import { axiosInstance } from "../../axios/axiosInstance";
import {
  ADMIN_API_URL,
  API_BASE_URL,
  getDefaultHeaders,
} from "../../config";

export const adminLogin = (credentials) =>
  axiosInstance.post(`${API_BASE_URL}/admin-login`, credentials, {
    headers: getDefaultHeaders(),
  });

export const adminLogout = (token) =>
  axiosInstance.post(
    `${ADMIN_API_URL}/logout`,
    {},
    {
      headers: {
        ...getDefaultHeaders(),
        Authorization: `Bearer ${token}`,
      },
      _skipAuthRedirect: true,
    },
  );

export const adminOtpVerify = ({ email, otp }) =>
  axiosInstance.post(
    `${API_BASE_URL}/admin-otp-verify`,
    { email, otp },
    {
      headers: getDefaultHeaders(),
    },
  );
